angular.module('bizmetryApp').controller('AgentsPanelController', function (
  $scope, $mdDialog, ProfileService, ReferenceDataService, $interval, $timeout,
  TelemetryAgentService, dialogService, $mdToast, ConfigurationService, $q
) {
  // ─── State ───────────────────────────────────────
  $scope.loading = true;
  $scope.refreshing = false;
  $scope.filteredAgents = [];
  $scope.profiles = [];
  $scope.envTypes = [];
  $scope.statuses = ['OFFLINE', 'ONLINE', 'SYNCING_UP', 'STARTING', 'STOPPING',
    'RESTARTING', 'STALLED', 'DRAINING', 'STALE', 'DECOMMISSIONING', 'RETIRED'];

  // ─── Filters ─────────────────────────────────────
  $scope.selectedProfile = 'ALL';
  $scope.selectedEnvType = 'ALL';
  $scope.selectedStatus = 'ALL';
  $scope.searchText = '';

  // ─── Refresh ─────────────────────────────────────
  $scope.refreshInterval = 10;
  $scope.isAnyDownloadInProgress = false;
  $scope.isDownloading = {};

  // ─── Selection ───────────────────────────────────
  $scope.selectedAgentIds = [];
  $scope.bulkActionInProgress = false;

  let agentsInterval = null;
  let debounceTimer = null;
  let isFirstLoad = true;
  let destroyed = false;
  let metricsDialogsOpen = 0;
  let listRequest = null;
  let listRequestSeq = 0;

  // ─── Reference data ───────────────────────────────
  function _loadFilterData() {
    ProfileService.getAllProfiles()
      .then(function (response) {
        $scope.profiles = response.data?.profiles || [];
      })
      .catch(function (err) { console.error('Error loading profiles:', err); });

    ReferenceDataService.getReferenceData('ENVIRONMENT_TYPE')
      .then(function (response) {
        $scope.envTypes = response.data || [];
      })
      .catch(function (err) { console.error('Error loading env types:', err); });
  }

  // ─── Agent enrichment ────────────────────────────
  function _getHashColor(label) {
    if (!label) return '#607d8b';
    const colors = ['#607d8b', '#8bc34a', '#03a9f4', '#ff9800', '#e91e63',
      '#9c27b0', '#009688', '#cddc39', '#ffc107', '#795548'];
    let hash = 0;
    for (let i = 0; i < label.length; i++) hash = label.charCodeAt(i) + ((hash << 5) - hash);
    return colors[Math.abs(hash) % colors.length];
  }

  function _getTextColor(label) {
    const hex = _getHashColor(label);
    const r = parseInt(hex.substr(1, 2), 16), g = parseInt(hex.substr(3, 2), 16), b = parseInt(hex.substr(5, 2), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) > 140 ? '#000000' : '#ffffff';
  }

  function _enrichAgent(agent) {
    const pc = _getHashColor(agent.profileName), ec = _getHashColor(agent.environmentName);
    return { ...agent, profilePillBg: pc, profilePillFg: _getTextColor(pc), envPillBg: ec, envPillFg: _getTextColor(ec) };
  }

  // ─── In-place reconciliation ──────────────────────
  function _updateInPlace(newAgents) {
    const existing = $scope.filteredAgents;
    const existingIdx = {};
    existing.forEach(function (a, i) { existingIdx[a.agentId] = i; });

    const newMap = {};
    newAgents.forEach(function (a) { newMap[a.agentId] = a; });

    for (let i = existing.length - 1; i >= 0; i--) {
      if (!newMap[existing[i].agentId]) existing.splice(i, 1);
    }
    existing.forEach(function (a, i) { existingIdx[a.agentId] = i; });

    newAgents.forEach(function (newAgent) {
      const idx = existingIdx[newAgent.agentId];
      if (idx !== undefined) {
        angular.extend(existing[idx], newAgent);
      } else {
        existing.push(newAgent);
      }
    });

    // Remove stale selections (agents no longer visible after filter/refresh)
    const visibleIds = new Set(newAgents.map(function (a) { return a.agentId; }));
    $scope.selectedAgentIds = $scope.selectedAgentIds.filter(function (id) { return visibleIds.has(id); });
  }

  // ─── Core fetch ───────────────────────────────────
  function _loadAgents() {
    if (destroyed || metricsDialogsOpen) return;
    const requestSeq = ++listRequestSeq;
    const cancel = $q.defer();
    listRequest = cancel;
    isFirstLoad ? ($scope.loading = true) : ($scope.refreshing = true);

    const accountId = JSON.parse(sessionStorage.getItem('user') || '{}').id;
    const profile = ($scope.selectedProfile === 'ALL' || !$scope.selectedProfile) ? null : $scope.selectedProfile;
    const envType = ($scope.selectedEnvType === 'ALL' || !$scope.selectedEnvType) ? null : $scope.selectedEnvType;
    const status = ($scope.selectedStatus === 'ALL' || !$scope.selectedStatus) ? null : $scope.selectedStatus;
    const search = ($scope.searchText || '').toLowerCase().trim();

    TelemetryAgentService.searchAgents(accountId, profile, null, envType, status, null, cancel.promise)
      .then(function (response) {
        if (destroyed || metricsDialogsOpen || requestSeq !== listRequestSeq) return;
        let agents = (response.data || []).map(_enrichAgent);
        if (search) agents = agents.filter(function (a) { return a.agentName.toLowerCase().includes(search); });

        if (isFirstLoad) {
          $scope.filteredAgents = agents;
          $timeout(function () { $scope.loading = false; isFirstLoad = false; }, 50);
        } else {
          _updateInPlace(agents);
          $scope.refreshing = false;
        }
      })
      .catch(function (err) {
        if (destroyed || metricsDialogsOpen || requestSeq !== listRequestSeq || err.status === -1) return;
        console.error('Error fetching agents:', err);
        if (isFirstLoad) {
          $scope.filteredAgents = [];
          $timeout(function () { $scope.loading = false; isFirstLoad = false; }, 50);
        } else {
          $scope.refreshing = false;
        }
      });
  }

  // ─── Filter controls ──────────────────────────────
  $scope.updateFilters = function () {
    if (debounceTimer) $timeout.cancel(debounceTimer);
    const delay = ConfigurationService.getFromCache('frontend.search_debounce_time') || 300;
    debounceTimer = $timeout(function () {
      isFirstLoad = true;
      _loadAgents();
    }, delay);
  };

  $scope.clearFilters = function () {
    $scope.selectedProfile = 'ALL';
    $scope.selectedEnvType = 'ALL';
    $scope.selectedStatus = 'ALL';
    $scope.searchText = '';
    isFirstLoad = true;
    _loadAgents();
  };

  // ─── Refresh interval ─────────────────────────────
  $scope.updateInterval = function () {
    if (agentsInterval) $interval.cancel(agentsInterval);
    agentsInterval = null;
    if (destroyed || metricsDialogsOpen) return;
    agentsInterval = $interval(_loadAgents, $scope.refreshInterval * 1000);
  };

  // ─── Dialog ──────────────────────────────────────
  $scope.close = function () {
    if (agentsInterval) $interval.cancel(agentsInterval);
    $mdDialog.hide();
  };

  // ─── Helpers ─────────────────────────────────────
  $scope.getOnlineCount = function () { return ($scope.filteredAgents || []).filter(function (a) { return a.agentStatus === 'ONLINE'; }).length; };
  $scope.getOfflineCount = function () { return ($scope.filteredAgents || []).filter(function (a) { return a.agentStatus === 'OFFLINE'; }).length; };

  // agent.upTime llega como duración en ms (no timestamp) — <bm-duration>
  // espera un "since" (epoch), lo convertimos acá para que el formato
  // días/horas/minutos sea consistente con el resto de la app.
  //
  // Memoizado por valor de entrada: bm-duration usa esto como binding
  // one-way ("since='<'"), y Angular lo re-evalúa en cada digest para
  // detectar cambios. Si devolviera Date.now() - ms sin cachear, el
  // resultado difiere en ~1ms cada vez que se llama — dos chequeos
  // consecutivos del MISMO digest nunca coinciden, y Angular tira
  // $rootScope:infdig (digest infinito) tras 10 iteraciones.
  var uptimeSinceCache = {};
  $scope.uptimeSince = function (ms) {
    if (!(ms || ms === 0)) return null;
    if (!(ms in uptimeSinceCache)) {
      uptimeSinceCache[ms] = Date.now() - ms;
    }
    return uptimeSinceCache[ms];
  };

  $scope.getMetricColor = function (value, min, max) {
    if (max === min || value === 0) return '#e0e0e0';
    return $scope.getPercentageColor(((value - min) / (max - min)) * 100);
  };

  $scope.getPercentageColor = function (pct) {
    if (pct < 30) return '#4caf50';
    if (pct < 60) return '#ff9800';
    if (pct < 85) return '#ff5722';
    return '#f44336';
  };

  // ─── Selection helpers ────────────────────────────
  $scope.isSelected = function (agent) {
    return $scope.selectedAgentIds.indexOf(agent.agentId) !== -1;
  };

  $scope.toggleSelect = function (agent) {
    const idx = $scope.selectedAgentIds.indexOf(agent.agentId);
    if (idx === -1) {
      $scope.selectedAgentIds.push(agent.agentId);
    } else {
      $scope.selectedAgentIds.splice(idx, 1);
    }
  };

  $scope.isAllSelected = function () {
    const onlineAgents = $scope.filteredAgents.filter(function (a) { return (a.agentStatus === 'ONLINE' || a.agentStatus === 'STALLED'); });
    return onlineAgents.length > 0 &&
      onlineAgents.every(function (a) { return $scope.selectedAgentIds.indexOf(a.agentId) !== -1; });
  };

  $scope.isIndeterminate = function () {
    const onlineAgents = $scope.filteredAgents.filter(function (a) { return (a.agentStatus === 'ONLINE' || a.agentStatus === 'STALLED'); });
    return $scope.selectedAgentIds.length > 0 && !$scope.isAllSelected() &&
      onlineAgents.some(function (a) { return $scope.selectedAgentIds.indexOf(a.agentId) !== -1; });
  };

  $scope.toggleSelectAll = function () {
    const onlineIds = $scope.filteredAgents
      .filter(function (a) { return (a.agentStatus === 'ONLINE' || a.agentStatus === 'STALLED'); })
      .map(function (a) { return a.agentId; });
    if ($scope.isAllSelected()) {
      $scope.selectedAgentIds = [];
    } else {
      $scope.selectedAgentIds = onlineIds;
    }
  };

  $scope.clearSelection = function () {
    $scope.selectedAgentIds = [];
  };

  // ─── Bulk actions ─────────────────────────────────
  function _getSelectedOnlineAgents() {
    return $scope.filteredAgents.filter(function (a) {
      return $scope.selectedAgentIds.indexOf(a.agentId) !== -1 && (a.agentStatus === 'ONLINE' || a.agentStatus === 'STALLED');
    });
  }

  $scope.bulkRestart = function () {
    const targets = _getSelectedOnlineAgents();
    if (targets.length === 0) {
      $mdToast.showSimple('No ONLINE agents selected to restart.');
      return;
    }
    const names = targets.map(function (a) { return '<strong>' + a.agentName + '</strong>'; }).join(', ');
    dialogService.showDecisionDialog(
      'Restart ' + targets.length + ' Agent' + (targets.length !== 1 ? 's' : ''),
      'Are you sure you want to restart the following agents?<br><br>' + names
    ).then(function (decision) {
      if (decision !== 'proceed') return;
      $scope.bulkActionInProgress = true;

      // ── FIX #1: optimistic status so pills show RESTARTING + spinner immediately ──
      targets.forEach(function (a) { a.agentStatus = 'RESTARTING'; });

      const promises = targets.map(function (a) {
        return TelemetryAgentService.restartAgent(a.agentId).catch(function (err) {
          console.error('Restart failed for agent ' + a.agentName + ':', err);
          a.agentStatus = 'ONLINE'; // roll back on failure
          return { failed: true, agentName: a.agentName };
        });
      });
      $q.all(promises).then(function (results) {
        const failed = results.filter(function (r) { return r && r.failed; });
        if (failed.length === 0) {
          $mdToast.showSimple(targets.length + ' agent' + (targets.length !== 1 ? 's' : '') + ' restarted successfully.');
        } else {
          const failedNames = failed.map(function (r) { return r.agentName; }).join(', ');
          dialogService.showErrorDialog('Partial Restart Failure',
            'Restart failed for: ' + failedNames + '. Others were restarted successfully.');
        }
        $scope.bulkActionInProgress = false;
        $scope.clearSelection();
        // ── FIX #2: refresh immediately after bulk action resolves ──
        _loadAgents();
      });
    });
  };

  $scope.bulkStop = function () {
    const targets = _getSelectedOnlineAgents();
    if (targets.length === 0) {
      $mdToast.showSimple('No ONLINE agents selected to stop.');
      return;
    }
    const names = targets.map(function (a) { return '<strong>' + a.agentName + '</strong>'; }).join(', ');
    dialogService.showDecisionDialog(
      'Stop ' + targets.length + ' Agent' + (targets.length !== 1 ? 's' : ''),
      'Are you sure you want to stop the following agents?<br><br>' + names
    ).then(function (decision) {
      if (decision !== 'proceed') return;
      $scope.bulkActionInProgress = true;

      // ── FIX #1: optimistic status so pills show STOPPING + spinner immediately ──
      targets.forEach(function (a) { a.agentStatus = 'STOPPING'; });

      const promises = targets.map(function (a) {
        return TelemetryAgentService.stopAgent(a.agentId).catch(function (err) {
          console.error('Stop failed for agent ' + a.agentName + ':', err);
          a.agentStatus = 'ONLINE'; // roll back on failure
          return { failed: true, agentName: a.agentName };
        });
      });
      $q.all(promises).then(function (results) {
        const failed = results.filter(function (r) { return r && r.failed; });
        if (failed.length === 0) {
          $mdToast.showSimple(targets.length + ' agent' + (targets.length !== 1 ? 's' : '') + ' stopped successfully.');
        } else {
          const failedNames = failed.map(function (r) { return r.agentName; }).join(', ');
          dialogService.showErrorDialog('Partial Stop Failure',
            'Stop failed for: ' + failedNames + '. Others were stopped successfully.');
        }
        $scope.bulkActionInProgress = false;
        $scope.clearSelection();
        // ── FIX #2: refresh immediately after bulk action resolves ──
        _loadAgents();
      });
    });
  };

  // ─── Agent actions ────────────────────────────────
  $scope.restartAgent = function (agent) {
    dialogService.showDecisionDialog('Restart Agent', `Are you sure you want to restart agent "<strong>${agent.agentName}</strong>"?`)
      .then(function (decision) {
        if (decision !== 'proceed') return;
        // ── FIX #1: optimistic status so pill shows RESTARTING + spinner immediately ──
        agent.agentStatus = 'RESTARTING';
        TelemetryAgentService.restartAgent(agent.agentId)
          .then(function () {
            $mdToast.showSimple('Agent restarted successfully');
            // ── FIX #2: refresh immediately after action ──
            _loadAgents();
          })
          .catch(function (err) {
            agent.agentStatus = 'ONLINE'; // roll back on failure
            console.error('Restart failed:', err);
            dialogService.showErrorDialog('Restart Failed', 'Could not restart the agent.');
          });
      });
  };

  $scope.stopAgent = function (agent) {
    dialogService.showDecisionDialog('Stop Agent', `Are you sure you want to stop agent "<strong>${agent.agentName}</strong>"?`)
      .then(function (decision) {
        if (decision !== 'proceed') return;
        // ── FIX #1: optimistic status so pill shows STOPPING + spinner immediately ──
        agent.agentStatus = 'STOPPING';
        TelemetryAgentService.stopAgent(agent.agentId)
          .then(function () {
            $mdToast.showSimple('Agent stopped successfully');
            // ── FIX #2: refresh immediately after action ──
            _loadAgents();
          })
          .catch(function (err) {
            agent.agentStatus = 'ONLINE'; // roll back on failure
            console.error('Stop failed:', err);
            dialogService.showErrorDialog('Stop Failed', 'Could not stop the agent.');
          });
      });
  };

  $scope.editAgent = function (agent) {
    TelemetryAgentService.getAgentDetails(agent.agentId)
      .then(function (response) {
        $mdDialog.show({
          controller: 'AgentConfigDialogController',
          templateUrl: 'profile/tabs/agents/configuration/agent-config-dialog.html',
          parent: angular.element(document.body),
          escapeToClose: false,
          multiple: true,
          clickOutsideToClose: true,
          locals: { agent: response.data }
        }).then(function (updated) { if (updated) _loadAgents(); });
      })
      .catch(function (err) {
        console.error('Error fetching agent data:', err);
        dialogService.showErrorDialog('Load Error', 'Could not load agent configuration.');
      });
  };

  $scope.viewLogs = function (agent) {
    $mdDialog.show({
      controller: 'AgentLogsDialogController',
      templateUrl: 'profile/tabs/agents/logs/agent-logs-dialog.html',
      clickOutsideToClose: true,
      escapeToClose: false,
      multiple: true,
      locals: { agent: agent }
    });
  };

  $scope.openDownloadDialog = function (agent) {
    if ($scope.isAnyDownloadInProgress) { $mdToast.showSimple('Another download is in progress.'); return; }
    $scope.isDownloading[agent.agentId] = true;
    $scope.isAnyDownloadInProgress = true;
    $mdDialog.show({
      templateUrl: 'profile/tabs/agents/download/download-dialog.html',
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      controller: 'DownloadAgentDialogController',
      multiple: true,
      escapeToClose: false,
      locals: { agent: agent }
    }).finally(function () {
      $scope.isDownloading[agent.agentId] = false;
      $scope.isAnyDownloadInProgress = false;
    });
  };

  $scope.openAgentMetrics = function (agent) {
    metricsDialogsOpen++;
    ++listRequestSeq;
    if (agentsInterval) $interval.cancel(agentsInterval);
    agentsInterval = null;
    if (debounceTimer) $timeout.cancel(debounceTimer);
    if (listRequest) listRequest.resolve();
    return TelemetryAgentService.getMetricsTimeRange(agent.agentId)
      .then(function (response) {
        if (response.status === 204 || !response.data?.minTimestamp) {
          const msg = `No metrics available for <strong>"${agent.agentName}"</strong>.` +
            ((agent.agentStatus !== 'ONLINE' && agent.agentStatus !== 'STALLED') ? `<br><br>Agent is <strong>${agent.agentStatus}</strong>. Start it to begin collecting data.` : '');
          dialogService.showInformationDialog('No Metrics Available', msg);
          return;
        }
        if (destroyed) return;
        return $mdDialog.show({
          controller: 'AgentStatsDialogController',
          templateUrl: '/profile/tabs/agents/stats/agent-stats-dialog.html',
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          multiple: true,
          locals: { agent: agent }
        }).catch(angular.noop);
      })
      .catch(function (err) {
        if (destroyed) return;
        if (err.status === 204) {
          dialogService.showInformationDialog('No Metrics Available', `No metrics available for <strong>"${agent.agentName}"</strong>.`);
          return;
        }
        dialogService.showErrorDialog('Error Loading Metrics', 'Could not check metrics availability. Please try again.');
      }).finally(function () {
        metricsDialogsOpen = Math.max(0, metricsDialogsOpen - 1);
        if (destroyed || metricsDialogsOpen) return;
        _loadAgents();
        $scope.updateInterval();
      });
  };

  $scope.openAgentDetails = function (agent) {
    $mdDialog.show({
      controller: 'AgentDetailsDialogController',
      templateUrl: 'profile/tabs/agents/details/agent-details-dialog.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: true,
      multiple: true,
      locals: {
        agent,
        profileId: agent.profileId,
        accountId: agent.accountId,
        refreshIntervalMs: $scope.refreshInterval * 1000,
        getEnvironmentTypeLabel: function () { return agent.envTypeName || 'N/A'; },
        formatSyncTime: function (ts) {
          if (!ts) return 'Never';
          const diff = Date.now() - new Date(ts).getTime();
          const m = Math.floor(diff / 60000), h = Math.floor(m / 60), d = Math.floor(h / 24);
          if (d > 0) return d + 'd ago';
          if (h > 0) return h + 'h ago';
          if (m > 0) return m + 'm ago';
          return 'Just now';
        },
        getLogPressureColor: function (p) { return p >= 80 ? '#f44336' : p >= 50 ? '#ff9800' : '#4caf50'; },
        openDownloadDialog: $scope.openDownloadDialog,
        editAgentConfig: $scope.editAgent,
        openAgentLogsDialog: function ($event, a) { $scope.viewLogs(a); },
        openStatsDialog: $scope.openAgentMetrics,
        restartAgent: $scope.restartAgent
      }
    });
  };

  $scope.$on('$destroy', function () {
    destroyed = true;
    if (agentsInterval) $interval.cancel(agentsInterval);
    if (debounceTimer) $timeout.cancel(debounceTimer);
    if (listRequest) listRequest.resolve();
  });

  // ─── Init ─────────────────────────────────────────
  _loadFilterData();
  _loadAgents();
  $scope.updateInterval();
});